import "./Turnover.css";
import { useState, useEffect, useMemo } from "react";
import InnerHeader from "../../components/InnerHeader";

export default function Turnover() {
  const [tab, setTab] = useState("active");
  const [loading, setLoading] = useState(true);
  const [turnovers, setTurnovers] = useState([]);

  /* ----------------------------------
     Fetch Turnovers
  -----------------------------------*/
  useEffect(() => {
    const fetchTurnovers = async () => {
      try {
        const token = localStorage.getItem("token");
        const remoteId = localStorage.getItem("remote_id");

        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/turnovers?remote_id=${remoteId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const data = await res.json();
        setTurnovers(data.turnover || []);
      } catch (err) {
        console.error("Turnover fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTurnovers();
  }, []);

  /* ----------------------------------
     Normalize API → UI data
  -----------------------------------*/
  const normalizedTurnovers = useMemo(() => {
    return turnovers.map((t) => {
      const total = Number(t.required_turnover || 0);
      const remaining = Number(t.remaining_turnover || 0);
      const current = total - remaining;

      return {
        ...t,
        status: t.status === "complete" ? "completed" : "active",
        amount: current,
        progress: {
          current,
          total,
        },
      };
    });
  }, [turnovers]);

  /* ----------------------------------
     Filter by tab
  -----------------------------------*/
  const filtered = normalizedTurnovers.filter((item) =>
    tab === "active" ? item.status === "active" : item.status === "completed"
  );

  return (
    <div className="turnover-page">
      <InnerHeader title="Turnover" />

      {/* Tabs */}
      <div className="tabs-turn">
        <span
          className={`tab-turn ${tab === "active" ? "active" : ""}`}
          onClick={() => setTab("active")}
        >
          Active
        </span>
        <span
          className={`tab-turn ${tab === "completed" ? "active" : ""}`}
          onClick={() => setTab("completed")}
        >
          Completed
        </span>
      </div>

      {/* Content */}
      <div className="turnover-list">
        {loading && <div className="empty">Data not available</div>}

        {!loading && filtered.length === 0 && (
          <div className="empty">No records</div>
        )}

        {!loading &&
          filtered.map((turnover) => {
            const { current, total } = turnover.progress;
            const percent =
              total > 0 ? Math.round((current / total) * 100) : 0;

            return (
              <div className="card-turn" key={turnover.id}>
                <div
                  className={`badge-turn ${
                    turnover.status === "completed"
                      ? "done"
                      : "active-badge"
                  }`}
                >
                  {turnover.status === "completed"
                    ? "✓ Completed"
                    : "Active"}
                </div>

                <div className="title-row">
                  <span className="title-turn">
                    {turnover.transaction?.promotion?.name ||
                      "Regular Deposit"}
                  </span>
                  <span className="info">ⓘ</span>
                </div>

                <div className="amount-turn">
                  ৳ {turnover.amount.toFixed(2)}
                </div>

                <div className="progress-row">
                  <span>
                    {current}/{total}
                  </span>
                  <span>{percent}%</span>
                </div>

                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{ width: `${percent}%` }}
                  />
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}